export default {"src":"/_next/static/media/gf.f7b582f6.svg","height":64,"width":56};